/* eslint-disable comma-dangle */
export const types = {
  productSetProducts: '@product/Set',
  productSetSearchResults: '@product/SetSearchResults',
  productAddProduct: '@product/AddProduct',
  uiSetCurrentPage: '@UI/SetCurrentPage',
  uiIncrementedPage: '@UI/IncrementedPage',
  uiDecrementedPage: '@UI/DecrementedPage',
  uiSetFilter: '@UI/SetFilter',
  uiSetOrder: '@UI/SetOrder',
  uiResetFilter: '@UI/ResetFilter',
  uiResetOrder: '@Ui/ResetOrder',
  uiShowResults: '@ui/ShowResults',
  uiHiddenResults: '@ui/HiddenResults'
};
